import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserActions, UserActitonTypes } from './user.actions';
import { User } from '../../_models/user';

export interface State extends fromRoot.State {
	users: UserState;
}

export interface UserState {
	currentUser: User;
	usersList: User[];
	error: string;

}

const initialState: UserState = {
	currentUser: null,
	usersList: [],
	error: ''
}

const getUserFeatureState = createFeatureSelector<UserState>('users');

export const getCurrentUser = createSelector(
	getUserFeatureState,
	state => state.currentUser
);

export const getUserdList = createSelector(
	getUserFeatureState,
	state => state.usersList
);

export const getError = createSelector(
	getUserFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: UserActions): UserState {

	// console.log('--> User Reducer --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action User type: ');
	// console.log(action.type);

	switch (action.type) {

		// case UserActitonTypes.GetCurrentUser:

		// 	console.log('--> Entando en acción GetCurrentUser.');

		// 	return state;

		case UserActitonTypes.SetCurrentUser:

			console.log('--> Entando en acción SetCurrentUser.');

			return {
				...state,
				currentUser: action.payload
			};

		case UserActitonTypes.ClearUser:

			console.log('--> Entando en acción ClearUser.');

			return {
					...state,
					currentUser: null
				};


		case UserActitonTypes.InicializeUser:

			console.log('--> Entando en acción InicializeUser.');

			return {
					...state,
					usersList: []
				};

		case UserActitonTypes.LoadSuccessUsers:

			console.log('--> Entando en acción LoadSuccessUsers.');

			return {
					...state,
					usersList: action.payload,
					error: ''
				};

		case UserActitonTypes.LoadFailUsers:

			console.log('--> Entando en acción LoadFailUsers.');

			return {
					...state,
					usersList: [],
					error: action.payload
				};

		default:
			return state;
	}
}